import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import FormGroup from '../../../generic/Forms/FormGroup';
import FormLabel from '../../../generic/Forms/FormLabel';
import InputBase from '../../../generic/Forms/InputBase';
import { Select } from '../../../generic/Select';
import Subheading from '../../../shared/settings/SettingsPageSubheading';
import type { SelectOption } from '../../../../types';
import type { InputRenderProps } from '../../../generic/Forms/InputBase';

import type { ProjectGeneralSettings } from './types';

import styles from './GeneralSettings.module.less';

const TimeoutInput = (inputBaseProps: InputRenderProps) => (
  <FormLabel
    label="Timeout"
  >
    <div className={`${inputBaseProps.className} ${styles.integrationhookTimeoutInputContainer}`}>
      <input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {..._.omit(inputBaseProps, 'className')}
        className={styles.integrationhookTimeoutInput}
        type="number"
      />
      <span className={styles.integrationhookTimeoutInputSuffix}>
        minutes
      </span>
    </div>
  </FormLabel>
);

type Props = {
  integrationhookTimeout: number;
  integrationhookFailState: SelectOption<ProjectGeneralSettings['integrationhook_fail_state']>;
  integrationHookFailStates: Array<SelectOption<ProjectGeneralSettings['integrationhook_fail_state']>>
  isSaving: boolean;
  onUpdate: (data: Partial<ProjectGeneralSettings>) => void;
};

/**
 * ProjectGeneralSettingsGitHubStatusChecks displays the GitHub status checks settings for a project.
 * This is only visible when the vsc_host is 'github'.
 */
const ProjectGeneralSettingsGitHubStatusChecks: VoidFunctionComponent<Props> = ({
  integrationhookTimeout,
  integrationhookFailState,
  integrationHookFailStates,
  isSaving,
  onUpdate,
}) => (
  <>
    <Subheading>
      GitHub Status Checks
    </Subheading>
    <p className={`${styles.smallText} ${styles.smallTextParagraph}`}>
      For projects hosted on GitHub, FOSSA will report a status check with the results of analyzing your build.
      {' '}
      You can configure this status check to timeout report either success or failure
      {' '}
      if the analysis cannot be completed in time.
    </p>
    <FormGroup>
      <InputBase
        label="Timeout"
        value={integrationhookTimeout}
        size="small"
        onChange={(timeout: number) => onUpdate({ integrationhook_timeout: timeout })}
      >
        {TimeoutInput}
      </InputBase>
      <FormLabel label="Failure mode">
        <Select
          id="project-settings-github-failure-mode"
          onChange={failureMode =>
            //  Note that this needs to be coerced to null instead of undefined, as this is nullable in the DB.
            //  This is because if you pass undefined the field will be ignored and not updated.
            onUpdate({ integrationhook_fail_state: failureMode?.value ?? null })}
          options={integrationHookFailStates}
          value={integrationhookFailState}
          isDisabled={isSaving}
        />
      </FormLabel>
    </FormGroup>
  </>
);

export default ProjectGeneralSettingsGitHubStatusChecks;
